<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VwHYTk/image/cover.jpg?1731429802808" alt="This image is the cover for the book Small Magics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Small Magics
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Your Hands-on, Back-to-Basics Guide to Building a Magical Practice</b><br/><br/>As if you're having face-to-face lessons on her porch, H. Byron Ballard introduces you to the ways of magic, answering vital questions about what it is, why it matters, and how to do it. She teaches the mechanics and foundational skills of practice, offering no-nonsense techniques that practitioners of any skill level or tradition can use.<br/><br/>Drawing from her many years as a practicing witch, Ballard demonstrates how to engage daily with the energy around you. She encourages you to experience magic with fresh eyes—whether you're a beginner or need to regain a beginner's mind. This book provides grounding exercises, shielding methods, healing magic, insight on witchcraft tools, and more. Ballard offers everything you need to live a full, enchanted life in our deliciously magical world.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H. Byron Ballard
      </h2>
      
      <p class="authorDescription body article"><P><B>H. Byron Ballard, BA, MFA</B> (Asheville, NC) is a western NC native, teacher, folklorist, and writer. She has served as a featured speaker and teacher at several festivals and conferences, including the Sacred Space Conference, Pagan Spirit Gathering, Starwood, Hexfest and many others. She serves as senior priestess and co-founder of Mother Grove Goddess Temple and the Coalition of Earth Religions/CERES, both in Asheville, NC. She podcasts about Appalachian folkways on "Wyrd Mountain Gals." Her essays are featured in several anthologies and she writes a regular column for <I>SageWoman Magazine</I>. Find her online at www.myvillagewitch.com.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?68509f59